"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtendLineStringMode = void 0;

var _geojsonEditMode = require("./geojson-edit-mode");

var _immutableFeatureCollection = require("./immutable-feature-collection");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ExtendLineStringMode = /*#__PURE__*/function (_GeoJsonEditMode) {
  _inherits(ExtendLineStringMode, _GeoJsonEditMode);

  var _super = _createSuper(ExtendLineStringMode);

  function ExtendLineStringMode() {
    _classCallCheck(this, ExtendLineStringMode);

    return _super.apply(this, arguments);
  }

  _createClass(ExtendLineStringMode, [{
    key: "getSingleSelectedLineString",
    value: function getSingleSelectedLineString(props) {
      var selectedGeometry = this.getSelectedGeometry(props);

      if (selectedGeometry && selectedGeometry.type === 'LineString') {
        return selectedGeometry;
      }

      return null;
    }
  }, {
    key: "handleClick",
    value: function handleClick(event, props) {
      var selectedIndexes = props.selectedIndexes;
      var selectedLineString = this.getSingleSelectedLineString(props);

      if (!selectedLineString) {
        console.warn("ExtendLineStringMode only supported for single LineString selection"); // eslint-disable-line

        return;
      } // Extend the LineString


      var positionIndexes = [selectedLineString.coordinates.length];
      var modeConfig = props.modeConfig;

      if (modeConfig && modeConfig.drawAtFront) {
        positionIndexes = [0];
      }

      var featureIndex = selectedIndexes[0];
      var updatedData = new _immutableFeatureCollection.ImmutableFeatureCollection(props.data).addPosition(featureIndex, positionIndexes, event.mapCoords).getObject();
      props.onEdit({
        updatedData: updatedData,
        editType: 'addPosition',
        editContext: {
          featureIndexes: [featureIndex],
          positionIndexes: positionIndexes,
          position: event.mapCoords
        }
      });
    }
  }, {
    key: "getGuides",
    value: function getGuides(props) {
      var guides = {
        type: 'FeatureCollection',
        features: []
      };
      var selectedLineString = this.getSingleSelectedLineString(props);

      if (!selectedLineString) {
        // nothing to do
        // @ts-ignore
        return guides;
      }

      var mapCoords = props.lastPointerMoveEvent && props.lastPointerMoveEvent.mapCoords; // Draw an extension line starting from one end of the selected LineString to the cursor

      var startPosition = null;
      var modeConfig = props.modeConfig;

      if (modeConfig && modeConfig.drawAtFront) {
        startPosition = selectedLineString.coordinates[0];
      } else {
        startPosition = selectedLineString.coordinates[selectedLineString.coordinates.length - 1];
      }

      guides.features.push({
        type: 'Feature',
        properties: {
          guideType: 'tentative'
        },
        geometry: {
          type: 'LineString',
          coordinates: [startPosition, mapCoords]
        }
      }); // @ts-ignore

      return guides;
    }
  }, {
    key: "handlePointerMove",
    value: function handlePointerMove(event, props) {
      props.onUpdateCursor('cell');
    }
  }]);

  return ExtendLineStringMode;
}(_geojsonEditMode.GeoJsonEditMode);

exports.ExtendLineStringMode = ExtendLineStringMode;